'use strict';

module.exports = function () {
    $(document).on('click', function (e) {
        if (!$(e.target).closest('.error-messaging .alert').length) {
            $('.error-messaging .alert').alert('close');
        }
    });
};
